import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as globalActions from 'app/ducks/global/actions';
import * as authActions from 'app/ducks/authentication/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as authenticationSelectors from 'app/ducks/authentication/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';

function selector(state): any {
  return {
    authentication: authenticationSelectors.getAuthentication(state),
    user: state.users,
    global: state.global,
    teams: teamsSelectors.getTeams(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(authActions, globalActions, teamsActions);

interface IAuthenticatedComponentProps {
  children: any;
  authentication: any;
  location: any;
  global: any;
  actions: any;
  teams: any;
  users: any;
  appReady: boolean;
}

interface IAuthenticatedComponentState {
  isAuthenticated: boolean;
  userId: string;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class AuthenticatedComponent extends React.Component<
IAuthenticatedComponentProps,
IAuthenticatedComponentState
> {
  static defaultProps: IAuthenticatedComponentProps = {
    children: undefined,
    authentication: undefined,
    location: undefined,
    global: undefined,
    actions: undefined,
    teams: undefined,
    users: undefined,
    appReady: false,
  };

  state: IAuthenticatedComponentState = {
    isAuthenticated: undefined,
    userId: undefined,
  }

  async componentDidMount(): Promise<void> {
    if (!this.props.global.isLoading && !this.props.global.hasLoaded) {
      await this.props.actions.globalLoad();
    }
    window.registerMobileDeviceToken = this.props.actions.registerMobileDeviceToken;
    window.checkUserAuthenticated = await authenticationSelectors.isAuthenticated;
    const isAuthenticated = await authenticationSelectors.isAuthenticated();
    const userId = await authenticationSelectors.getUserId();

    this.setState({
      isAuthenticated,
      userId,
    });
  }

  render(): React.ReactNode {
    const renderChildren = this.state.isAuthenticated && this.props.appReady && this.props.global.hasLoaded;

    return (
      <div className="h-100 m-h-100">
        {renderChildren ? this.props.children : <div />}
      </div>
    );
  }
}
